// extracted by mini-css-extract-plugin
export default {"rootClassName":"pre-etapa-3-route"};